class FormProducer {
    name;
    document_number;
    phone;
    email;
    insc_estadual;
    lat;
    lng;
    logradouro;
    state_addr;
    number;
    pais_addr;
    city_addr;
    zipcode;
    bairro_addr;
    address;
}

class FormProperty {
    id;
    name;
    total_area;
    area_scale;
    count_residentes_family;
    count_has_insc_estadual_f;
    count_trabalhadores;
    count_has_insc_estadual_t;
}

class FormLand {
    id;
    production_title;
    production_year;
    product_ids = [1];
    units_count;
    production_units;
    production_guiada;
    production_scale;
    total_area;
    area_scale;
}

export default class Producer {
    producers = [];
    props = [];
    lands = [];
    currentStep = 0;
    currentProducer;
    currentProp;
    currentPropBtn;
    currentLand;
    currentLandBtn;

    steps = [
        ['form-producer-dados', 'Dados do Produtor'], 
        ['form-producer-address', 'Endereço do Produtor'], 
        ['form-producer-property', 'Terra do Produtor'], 
        ['form-producer-land-production', 'Produção do Produtor'],
        ['form-producer-finalize', 'Verficar dados']
    ];

    producerDataFields = [
        'producer_registration_producer_name',
        'producer_registration_producer_document_number',
        'producer_registration_producer_phone',
        'producer_registration_producer_email',
        'producer_registration_producer_insc_estadual'
    ];

    producerAddressFields = [
        'producer_registration_producer_lat',
        'producer_registration_producer_lng',
        'producer_registration_producer_logradouro',
        'producer_registration_producer_state_addr',
        'producer_registration_producer_number',
        'producer_registration_producer_pais_addr',
        'producer_registration_producer_zipcode',
        'producer_registration_producer_city_addr',
        'producer_registration_producer_bairro_addr',
        'producer_registration_producer_address'
    ];

    producerPropertyFields = [
        'producer_registration_producer_property_name',
        'producer_registration_producer_property_total_area',
        'producer_registration_producer_property_scale_area',
        'producer_registration_producer_property_count_residentes_family',
        'producer_registration_producer_property_count_has_insc_estadual_f',
        'producer_registration_producer_property_count_trabalhadores',
        'producer_registration_producer_property_count_has_insc_estadual_t'
    ];

    producerLandFields = [
        'producer_registration_land_production_title',
        'producer_registration_land_production_year',
        'producer_registration_land_product_ids',
        'producer_registration_land_units_count',
        'producer_registration_land_production_units',
        'producer_registration_land_production_guiada',
        'producer_registration_land_production_scale',
        'producer_registration_land_total_area',
        'producer_registration_land_area_scale'
    ];

    currentStepButton;
    constructor()
    {
        this.currentProducer = new FormProducer();
        this.producers.push(this.currentProducer);
        this.props = [];
        this.lands = [];
        console.log('Construtor producer');
    }
    // producer data
    FProducerDataAddKeyPressedEvent()
    {
        let i = 0;
        while(i < this.producerDataFields.length)
        {
            try {
                let field = document.getElementById(this.producerDataFields[i]);
                field.addEventListener("keyup", this.FieldPrepareProducerData);
                field.addEventListener("change", this.FieldPrepareProducerData);
                field.addEventListener("focus", this.FieldPrepareProducerData);

            } catch(error)
            {
                console.log(error);
                break;
            }

            i++;
        }
        i = 0;
        while(i < this.producerAddressFields.length)
        {
            try {
                let field = document.getElementById(this.producerAddressFields[i]);
                field.addEventListener("keyup", this.FieldPrepareProducerData);
                field.addEventListener("onchange", this.FieldPrepareProducerData);
            } catch(error)
            {
                console.log(error);
                break;
            }
            i++;
        }
    }

    FieldPrepareProducerData(e)
    {
        if (e.target.id == "producer_registration_producer_name")
        {
            window.Producer.currentProducer.name = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_document_number")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentProducer.document_number = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_phone")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentProducer.phone = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_email")
        {
            window.Producer.currentProducer.email = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_insc_estadual")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentProducer.insc_estadual = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_lat")
        {
            window.Producer.currentProducer.lat = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_lng")
        {
            window.Producer.currentProducer.lng = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_logradouro")
        {
            window.Producer.currentProducer.logradouro = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_state_addr")
        {
            window.Producer.currentProducer.state_addr = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_number")
        {
            window.Producer.currentProducer.number = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_pais_addr")
        {
            window.Producer.currentProducer.pais_addr = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_zipcode")
        {
            window.Producer.currentProducer.zipcode = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_city_addr")
        {
            window.Producer.currentProducer.city_addr = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_bairro_addr")
        {
            window.Producer.currentProducer.bairro_addr = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_address")
        {
            window.Producer.currentProducer.address = e.target.value;
        }
        if (e.target.value.length > 0)
        {
            e.target.style = ""
        } else {
            e.target.style = "background: #ff00008c; color: white;"
        }
                
    }

    // property data
    FPropertyAddKeyPressedEvent()
    {
        let i = 0;
        while(i < this.producerPropertyFields.length)
        {
            try {
                let field = document.getElementById(this.producerPropertyFields[i]);
                field.addEventListener("keyup", this.FieldPreparePropertyData);
                field.addEventListener("change", this.FieldPreparePropertyData);
            } catch(error)
            {
                console.log(error);
                break;
            }
            i++;
        }
    }

    FieldPreparePropertyData(e)
    {
        if (e.target.id == "producer_registration_producer_property_name")
        {
            window.Producer.currentProp.name = e.target.value;
            window.Producer.currentPropBtn.innerHTML = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_property_total_area")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentProp.total_area = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_property_scale_area")
        {
            window.Producer.currentProp.area_scale = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_property_count_residentes_family")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentProp.count_residentes_family = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_property_count_has_insc_estadual_f")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentProp.count_has_insc_estadual_f = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_property_count_trabalhadores")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentProp.count_trabalhadores = e.target.value;
        }
        if (e.target.id == "producer_registration_producer_property_count_has_insc_estadual_t")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentProp.count_has_insc_estadual_t = e.target.value;
        }
        if (e.target.value.length > 0)
        {
            e.target.style = ""
        } else {
            e.target.style = "background: #ff00008c; color: white;"
        }
    }

    AddPropertyNew()
    {
        this.currentProp = new FormProperty();
        this.props.push(this.currentProp);
        this.currentProp.name = `Propriedade ${this.props.length}`;
        this.currentProp.total_area = 0;
        this.currentProp.area_scale = "Mtr(s)²";
        this.currentProp.count_residentes_family = 0;
        this.currentProp.count_has_insc_estadual_f = 0;
        this.currentProp.count_trabalhadores = 0;
        this.currentProp.count_has_insc_estadual_t = 0;
        
        //add list element
        let box = document.getElementById('list-properties');
        let row = document.createElement('div');
        row.classList.add('flex-container-property');
        
        let btnProp = document.createElement('button');
        btnProp.innerHTML = this.currentProp.name;
        btnProp.className = "btn-prop";

        btnProp.onclick = this.SetCurrentPropertyF;
        if (window.Producer.currentPropBtn != null) 
        {
            window.Producer.currentPropBtn.classList.remove('property-selected');
        }
       if (document.getElementById(`prop_${this.props.length}`))
        {
            btnProp.id = `prop_${this.props.length + 1}`;
            this.currentProp.id = `prop_${this.props.length + 1}`;
        } else {
            btnProp.id = `prop_${this.props.length}`;
            this.currentProp.id = `prop_${this.props.length}`;
        }
        window.Producer.currentPropBtn = btnProp;
        window.Producer.currentPropBtn.classList.add('property-selected');

        let btnPropRemove = document.createElement('button');
        btnPropRemove.innerHTML = "X";
        btnPropRemove.className = "btn-prop-remove";
        btnPropRemove.onclick = this.RemoveProperty;
        
        row.appendChild(btnProp);
        row.appendChild(btnPropRemove);
        box.appendChild(row);
        
        // reset fields values
        let i = 0;
        while (i < this.producerPropertyFields.length)
        {
            let field = document.getElementById(this.producerPropertyFields[i]);
            field.value = "";
            field.type == "number" ? field.value = "0" : field.value = "";
            i++;
        }

        // set default fields values

        document.getElementById('producer_registration_producer_property_name').value = this.currentProp.name;
        document.getElementById('producer_registration_producer_property_total_area').value = window.Producer.currentProp.total_area;
        document.getElementById('producer_registration_producer_property_scale_area').value = window.Producer.currentProp.area_scale;
    }

    RemoveProperty(e)
    {
        if (window.Producer.props.length > 1)
        {
            let parent = e.target.parentElement;
            let btnProp = parent.firstChild;
            window.Producer.props = window.Producer.props.filter(prop => prop.id !== btnProp.id);
            parent.remove();
            window.Producer.currentProp = window.Producer.props.at(-1);
            window.Producer.currentPropBtn = document.getElementById('list-properties').lastElementChild.firstChild; // button
            window.Producer.currentPropBtn.classList.add('property-selected');
            // preencher campos com os dados da propriedade selecionada
            document.getElementById('producer_registration_producer_property_name').value = window.Producer.currentProp.name;
            document.getElementById('producer_registration_producer_property_total_area').value = window.Producer.currentProp.total_area;
            document.getElementById('producer_registration_producer_property_scale_area').value = window.Producer.currentProp.area_scale;
            document.getElementById('producer_registration_producer_property_count_residentes_family').value = window.Producer.currentProp.count_residentes_family;
            document.getElementById('producer_registration_producer_property_count_has_insc_estadual_f').value = window.Producer.currentProp.count_has_insc_estadual_f;
            document.getElementById('producer_registration_producer_property_count_trabalhadores').value = window.Producer.currentProp.count_trabalhadores;
            document.getElementById('producer_registration_producer_property_count_has_insc_estadual_t').value = window.Producer.currentProp.count_has_insc_estadual_t;
        }
    }

    SetCurrentPropertyF(e)
    {
        let idProp = e.target.id;
        if (window.Producer.currentPropBtn != null) 
        {
            window.Producer.currentPropBtn.classList.remove("property-selected");
        }
        window.Producer.currentPropBtn = e.target;
        window.Producer.currentPropBtn.classList.add('property-selected');
        window.Producer.currentProp = window.Producer.props.find(prop => prop.id == idProp);
        // preencher campos com os dados da propriedade selecionada
        document.getElementById('producer_registration_producer_property_name').value = window.Producer.currentProp.name;
        document.getElementById('producer_registration_producer_property_total_area').value = window.Producer.currentProp.total_area;
        document.getElementById('producer_registration_producer_property_scale_area').value = window.Producer.currentProp.area_scale;
        document.getElementById('producer_registration_producer_property_count_residentes_family').value = window.Producer.currentProp.count_residentes_family;
        document.getElementById('producer_registration_producer_property_count_has_insc_estadual_f').value = window.Producer.currentProp.count_has_insc_estadual_f;
        document.getElementById('producer_registration_producer_property_count_trabalhadores').value = window.Producer.currentProp.count_trabalhadores;
        document.getElementById('producer_registration_producer_property_count_has_insc_estadual_t').value = window.Producer.currentProp.count_has_insc_estadual_t;

        window.Producer.CloseListProperties();
    }

    OpenListProperties(id = 'properties-list')
    {
        let box = document.getElementById(id);
        box.classList.add('show');
    }

    CloseListProperties(id = 'properties-list')
    {
        let box = document.getElementById(id);
        box.classList.remove('show');
    }

    // land data
    FLandAddKeyPressedEvent()
    {
        let i = 0;
        while(i < this.producerLandFields.length)
        {
            try {
                let field = document.getElementById(this.producerLandFields[i]);
                field.addEventListener("keyup", this.FieldPrepareLandData);
                field.addEventListener("change", this.FieldPrepareLandData);
            } catch(error)
            {
                console.log(error);
                break;
            }
            i++;
        }
    }

    FieldPrepareLandData(e)
    {
        if (e.target.id == "producer_registration_land_production_title")
        {
            window.Producer.currentLand.production_title = e.target.value;
            window.Producer.currentLandBtn.innerHTML = e.target.value;
        }
        if (e.target.id == "producer_registration_land_production_year")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentLand.production_year = e.target.value;
        }
        if (e.target.id == "producer_registration_land_products")
        {
            window.Producer.currentLand.products = [e.target.value];
        }
        if (e.target.id == "producer_registration_land_units_count")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentLand.units_count = e.target.value;
        }
        if (e.target.id == "producer_registration_land_production_units")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentLand.production_units = e.target.value;
        }
        if (e.target.id == "producer_registration_land_production_guiada")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentLand.production_guiada = e.target.value;
        }
        if (e.target.id == "producer_registration_land_production_scale")
        {
            window.Producer.currentLand.production_scale = e.target.value;
        }
        if (e.target.id == "producer_registration_land_total_area")
        {
            e.target.value = e.target.value.replace(/\D/g, '');
            window.Producer.currentLand.total_area = e.target.value;
        }
        if (e.target.id == "producer_registration_land_area_scale")
        {
            window.Producer.currentLand.area_scale = e.target.value;
        }
        if (e.target.value.length > 0)
        {
            e.target.style = ""
        } else {
            e.target.style = "background: #ff00008c; color: white;"
        }
    }

    AddLandNew()
    {
        this.currentLand = new FormLand();
        this.lands.push(this.currentLand);
        this.currentLand.production_title = `Produção ${this.lands.length}`;
        this.currentLand.production_year = 0;
        this.currentLand.product_ids = [1];
        this.currentLand.units_count = 0;
        this.currentLand.production_units = 0;
        this.currentLand.production_guiada = 0;
        this.currentLand.total_area = 0;
        this.currentLand.production_scale = "Arroba(s)";
        this.currentLand.total_area = 0;
        this.currentLand.area_scale = "Mtr(s)²";

        //add list element
        let box = document.getElementById('list-lands');
        let row = document.createElement('div');
        row.classList.add('flex-container-property');

        let btnProd = document.createElement('button');
        btnProd.innerHTML = this.currentLand.production_title;
        btnProd.className = "btn-prop";

        btnProd.onclick = this.SetCurrentLandF;
        if (window.Producer.currentLandBtn != null) 
        {
            window.Producer.currentLandBtn.classList.remove('property-selected');
        }
        if (document.getElementById(`prod_${this.lands.length}`))
        {
            btnProd.id = `prod_${this.lands.length + 1}`;
            this.currentLand.id = `prod_${this.lands.length + 1}`;
        } else {
            btnProd.id = `prod_${this.lands.length}`;
            this.currentLand.id = `prod_${this.lands.length}`;
        }
        window.Producer.currentLandBtn = btnProd;
        window.Producer.currentLandBtn.classList.add('property-selected');

        let btnProdRemove = document.createElement('button');
        btnProdRemove.innerHTML = "X";
        btnProdRemove.className = "btn-prop-remove";
        btnProdRemove.onclick = this.RemoveLand;

        row.appendChild(btnProd);
        row.appendChild(btnProdRemove);
        box.appendChild(row);

        // reset fields values
        let i = 0;
        while (i < this.producerLandFields.length)
        {
            let field = document.getElementById(this.producerLandFields[i]);
            field.type == "number" ? field.value = "0" : field.value = "";
            i++;
        }

        // set default fields values
        document.getElementById('producer_registration_land_production_title').value = window.Producer.currentLand.production_title;
        document.getElementById('producer_registration_land_production_year').value = window.Producer.currentLand.production_year;
        document.getElementById('producer_registration_land_product_ids').value = window.Producer.currentLand.product_ids[0];
        document.getElementById('producer_registration_land_units_count').value = window.Producer.currentLand.units_count;
        document.getElementById('producer_registration_land_production_units').value = window.Producer.currentLand.production_units;
        document.getElementById('producer_registration_land_production_guiada').value = window.Producer.currentLand.production_guiada;
        document.getElementById('producer_registration_land_production_scale').value = window.Producer.currentLand.production_scale;
        document.getElementById('producer_registration_land_total_area').value = window.Producer.currentLand.total_area;
        document.getElementById('producer_registration_land_area_scale').value = window.Producer.currentLand.area_scale;
    }

    SetCurrentLandF(e)
    {
        let idLand = e.target.id;
        if (window.Producer.currentLandBtn != null) 
        {
            window.Producer.currentLandBtn.classList.remove("property-selected");
        }
        window.Producer.currentLandBtn = e.target;
        window.Producer.currentLandBtn.classList.add('property-selected');
        window.Producer.currentLand = window.Producer.lands.find(land => land.id == idLand);
        // preencher campos com os dados da propriedade selecionada
        document.getElementById('producer_registration_land_production_title').value = window.Producer.currentLand.production_title;
        document.getElementById('producer_registration_land_production_year').value = window.Producer.currentLand.production_year;
        document.getElementById('producer_registration_land_product_ids').value = window.Producer.currentLand.product_ids[0];
        document.getElementById('producer_registration_land_units_count').value = window.Producer.currentLand.units_count;
        document.getElementById('producer_registration_land_production_units').value = window.Producer.currentLand.production_units;
        document.getElementById('producer_registration_land_production_guiada').value = window.Producer.currentLand.production_guiada;
        document.getElementById('producer_registration_land_production_scale').value = window.Producer.currentLand.production_scale;
        document.getElementById('producer_registration_land_total_area').value = window.Producer.currentLand.total_area;
        document.getElementById('producer_registration_land_area_scale').value = window.Producer.currentLand.area_scale;

        window.Producer.CloseListProperties('lands-list');
    }

    RemoveLand(e)
    {
        if (window.Producer.lands.length > 1)
        {
            let parent = e.target.parentElement;
            let btnProp = parent.firstChild;
            window.Producer.lands = window.Producer.lands.filter(prop => prop.id !== btnProp.id);
            parent.remove();
            window.Producer.currentLand = window.Producer.lands.at(-1);
            window.Producer.currentLandBtn = document.getElementById('list-lands').lastElementChild.firstChild; // button
            window.Producer.currentLandBtn.classList.add('property-selected');
            // preencher campos com os dados da propriedade selecionada
            document.getElementById('producer_registration_land_production_title').value = window.Producer.currentLand.production_title;
            document.getElementById('producer_registration_land_production_year').value = window.Producer.currentLand.production_year;
            document.getElementById('producer_registration_land_product_id').value = window.Producer.currentLand.product_id;
            document.getElementById('producer_registration_land_units_count').value = window.Producer.currentLand.units_count;
            document.getElementById('producer_registration_land_production_units').value = window.Producer.currentLand.production_units;
            document.getElementById('producer_registration_land_production_guiada').value = window.Producer.currentLand.production_guiada;
            document.getElementById('producer_registration_land_production_scale').value = window.Producer.currentLand.production_scale;
            document.getElementById('producer_registration_land_total_area').value = window.Producer.currentLand.total_area;
            document.getElementById('producer_registration_land_area_scale').value = window.Producer.currentLand.area_scale;
        }
    }

    ActionSidebar()
    {
        const sidebar = document.getElementById('sidebar');
        const actionBar = document.getElementById('action-bar');
        if (sidebar.classList.contains("Hide"))
        {
            sidebar.classList.remove("Hide");
            sidebar.classList.add("Show");
            setTimeout(() => { 
                sidebar.style = "width:70%;"; 
                actionBar.style = "";
                for (let button of sidebar.lastElementChild.children)
                {
                    button.style.display = "block";
                }
            },300);
            
        } else {
            for (let button of sidebar.lastElementChild.children)
            {
                button.style.display = "none";
            }
            sidebar.classList.remove("Show");
            sidebar.classList.add("Hide");
            setTimeout(() => { sidebar.style = "", actionBar.style.width = "40px"},300);
        }


    }

    ValidProducerDataFields()
    {
        let i = 0;
        let valid = true;
        while(i < this.producerDataFields.length)
        {
            /*if (this.producerDataFields[i] == "producer_registration_producer_insc_estadual")
            {
                i++;
                continue;
            }*/
            let f = document.getElementById(this.producerDataFields[i]);
            f.style = "";
            if (!f.value.length > 0)
            {
                f.style.background = "red";
                f.style.color = "white";
                valid = false;
                break;
            }
            i++;
        }

        return valid;
    }

    ValidProducerAddressFields()
    {
        let i = 0;
        let valid = true;
        while(i < this.producerAddressFields.length)
        {
            if (this.producerAddressFields[i] == "producer_registration_producer_lat" || this.producerAddressFields[i] == "producer_registration_producer_lng")
            {
                i++;
                continue;
            }
            let f = document.getElementById(this.producerAddressFields[i]);
            f.style = "";
            if (!f.value.length > 0)
            {
                f.style.background = "red";
                f.style.color = "white";
                valid = false;
                break;
            }
            i++;
        }

        return valid;
    }

    ValidProducerPropertyFields()
    {
        let i = 0;
        let valid = true;
        while(i < this.producerPropertyFields.length)
        {
            let f = document.getElementById(this.producerPropertyFields[i]);
            f.style = "";
            if (!f.value.length > 0)
            {
                f.style.background = "red";
                f.style.color = "white";
                valid = false;
                break;
            }
            i++;
        }

        return valid;
    }

    ValidProducerLandFields()
    {
        let i = 0;
        let valid = true;
        while(i < this.producerLandFields.length)
        {
            let f = document.getElementById(this.producerLandFields[i]);
            f.style = "";
            if (!f.value.length > 0)
            {
                f.style.background = "red";
                f.style.color = "white";
                valid = false;
                break;
            }
            i++;
        }

        return valid;
    }

    NavigateToStep(e, index_id)
    {
        if (this.currentStep < 1 && !this.ValidProducerDataFields())
        {
            return 0;
        }
        if (this.currentStep == 1 && !this.ValidProducerAddressFields())
        {
            return 0;
        }
        if (this.currentStepButton)
        {
            if (document.getElementById("sidebar").classList.contains("Hide")) {
                this.currentStepButton.style = "display:none;";
            } else {
                this.currentStepButton.style = "display:block;";
            }
        }
        this.currentStepButton = e;
        this.currentStepButton.style.background = "#87e393";
        this.currentStepButton.style.color = "white";
        this.currentStepButton.style.fontWeight = "700";
        this.currentStep = index_id;
        this.PrepareFinalizeView();
        const step = document.getElementById('form-step').firstElementChild;
        steps.appendChild(step);
        let nextStp = document.getElementById(this.steps[index_id][0]);
        document.getElementById('title-step').innerHTML = this.steps[index_id][1];
        document.getElementById('form-step').appendChild(nextStp);
    }

    NextStep()
    {
        const stepsList = document.getElementById('steps').children;
        if (this.currentStep < 1 && !this.ValidProducerDataFields())
        {
            return 0;
        }
        if (this.currentStep == 1 && !this.ValidProducerAddressFields())
        {
            return 0;
        }
        if (this.currentStep == 2 && !this.ValidProducerPropertyFields())
        {
            return 0;
        }
        if (this.currentStep == 3 && !this.ValidProducerLandFields())
        {
            return 0;
        }
        if ((this.currentStep + 1) < 5)
        {
            this.PrepareFinalizeView();
            this.currentStep = this.currentStep + 1;
            const step = document.getElementById('form-step').firstElementChild;
            steps.appendChild(step);
            let nextStp = document.getElementById(this.steps[this.currentStep][0]);
            document.getElementById('title-step').innerHTML = this.steps[this.currentStep][1];
            document.getElementById('form-step').appendChild(nextStp);
            let button = document.getElementById("navigate_buttons").children[this.currentStep];
            this.NavigateToStep(button, this.currentStep);
            button.style.display = "none";
        }

        let next = document.getElementById("btn_next_step");
        if (next.attributes.create.value === "true" && this.currentStep == 4)
        {
            // enviar uma requisição post para o backend
            let pkg = {
                producer:   window.Producer.currentProducer,
                properties: window.Producer.props,
                lands:      window.Producer.lands
            }
            this.Submit(pkg);
        }
        
        if (this.currentStep == 4)
        {
            next.innerHTML = "Salvar";
            next.attributes.create.value = "true";
        }
    }

    PrevStep()
    {
        const stepsList = document.getElementById('steps').children;
        
        if (this.currentStep >= 1) {
            this.currentStep = this.currentStep - 1;
            const step = document.getElementById('form-step').firstElementChild;
            steps.appendChild(step);
            let nextStp = document.getElementById(this.steps[this.currentStep][0]);
            document.getElementById('title-step').innerHTML = this.steps[this.currentStep][1];
            document.getElementById('form-step').appendChild(nextStp);
            let button = document.getElementById("navigate_buttons").children[this.currentStep];
            this.NavigateToStep(button, this.currentStep);
            button.style.display = "none";
        }
        let next = document.getElementById("btn_next_step");
        next.innerHTML = "Avançar";
        next.attributes.create.value = "false";
    }

    // FINALIZE VIEW
    PrepareFinalizeView()
    {
        // reset content
        document.getElementById("producer_data_container").innerHTML = "";
        document.getElementById("producer_data_properties").innerHTML = "";
        document.getElementById("producer_data_lands").innerHTML = "";
        // criar botão para cada parte do formulario
        // producer
        let producerBtn = document.createElement('button');
        producerBtn.className = "producer-btn-view";
        producerBtn.innerHTML = window.Producer.currentProducer.name;

        let producerContainer = document.getElementById("producer_data_container");
        producerContainer.appendChild(producerBtn);
        
        // terras
        let i = 0;
        while(i < window.Producer.props.length)
        {
            let propBtn = document.createElement("button");
            propBtn.className = "producer-btn-view";
            propBtn.innerHTML = window.Producer.props[i].name;

            let propContainer = document.getElementById("producer_data_properties");
            propContainer.appendChild(propBtn);
            i++;
        }

        // areas de producao
        i = 0;
        while(i < window.Producer.lands.length)
        {
            let landBtn = document.createElement("button");
            landBtn.className = "producer-btn-view";
            landBtn.innerHTML = window.Producer.lands[i].production_title;

            let prodContainer = document.getElementById("producer_data_lands");
            prodContainer.appendChild(landBtn);
            i++;
        }
    }

    // send form
    Submit(pkg)
    {
        let modal = document.getElementById('modal_finalize');
        modal.style.display = "block";
        let w = 1;
        let progress_view = document.getElementById('progress_view');
        let idAnim = setInterval(() => {
            progress_view.style.width = `${w}%`;
            w++;
            if (w > 89)
            {
                clearInterval(idAnim);
            }
        },500);
        fetch('/produtoresdsl/create', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': document.getElementsByName('authenticity_token')[0].value },
            body: JSON.stringify(pkg)
        })
        .then(response => response.json())
        .then(data => {
            if (data.errors) {
                console.error("Erro:", data.errors);
                alert("Erro: "+data.errors[0]);
                modal.style = "";
                progress_view.style = "";
                if (data.status_code == 401)
                {
                    window.location.reload();
                    return 0;
                }
                alert("Por favor, tente novamente.");
            } else {
                console.log("Sucesso:", data);
                progress_view.style.width = `100%`;
                alert(data.message);
                window.location.reload();
            }
            clearInterval(idAnim);
            setTimeout(() => {
                modal.style = "";
                progress_view.style = "";
            }, 3000);

        })
        .catch(error => console.error("Falha:", error));
    }
}